import { useCallback, useRef, useState, useEffect } from 'react';

export const useEventListener = (target, type, listener, ...rest) => {
    useEffect(() => {
        // in a Node environment, exit early
        if (!target || typeof target.addEventListener !== 'function') {
            return;
        }

        target.addEventListener(type, listener, ...rest);

        // return a callback, which is called on unmount
        return () => {
            target.removeEventListener(type, listener, ...rest);
        };
    }, [listener, rest, target, type]);
};

export const useDropdown = () => {
    const elementRef = useRef(null);
    const triggerRef = useRef(null);
    const [expanded, setExpanded] = useState(false);

    // collapse on mousedown outside of the element and trigger.
    const maybeCollapse = useCallback(({ target }) => {
        const isOutsideElement =
            !elementRef.current || !elementRef.current.contains(target);
        const isOutsideTrigger =
            !triggerRef.current || !triggerRef.current.contains(target);

        if (isOutsideElement && isOutsideTrigger) {
            setExpanded(false);
        }
    }, []);

    // add listener to document, as an effect
    useEventListener(globalThis.document, 'mousedown', maybeCollapse);

    return {
        elementRef,
        expanded,
        setExpanded,
        triggerRef
    };
};
